let actualRouter = null;

export function setActualRouter (router) {
  actualRouter = router;
}

export function getActualRouter () {
  if (!actualRouter) {
    throw new Error('[router] Router is not initialized yet');
  }
  return actualRouter;
}
